import { createAction } from "@reduxjs/toolkit";

export const apiCall = createAction("apiCall");
/* -------------------------------------------------------------------------- */
/*                                 Reset Store                                */
/* -------------------------------------------------------------------------- */
export const resetStore = createAction("RESET_STORE");
